// @flow

import * as React from 'react';
import R from 'ramda';

import {
  ACCESS_CONTROL_PROPS,
  ACCESS_LEVEL_DOCS
} from '../../support/accessControlConstants';

import AccessControlWrapper from './AccessControlWrapper';
import Button from '../core/Button';
import HoverButton, { HOVER_BUTTON_PROPS } from '../core/HoverButton';
import Link from '../core/Link';

type InnerButtonProps = {
  accessDenied: boolean,
  i13nModel: Object,
  icon?: string,
  type?: string,
  children?: Node
};

class AccessInnerButton extends React.PureComponent<InnerButtonProps> {
  static defaultProps = {
    icon: (
      <img
        className="add-field-icon"
        src="/static/images/editor/ic_add_button.svg"
      />
    )
  };
  render() {
    // If enabled, we want to show a regular button or hover depending on what props are passed in
    if (!this.props.accessDenied) {
      const isHover = Object.keys(this.props).some(p =>
        HOVER_BUTTON_PROPS.includes(p)
      );
      const buttonProps = R.omit(['containerClassName'], this.props);
      return isHover ? (
        <HoverButton {...this.props} />
      ) : (
        <Button {...buttonProps}>
          {this.props.children}
          {this.props.icon}
        </Button>
      );
    }

    // If disabled due to access control, we want to show a tooltip on hover
    const i13nModel = { ...this.props.i13nModel };
    i13nModel.params = R.merge(
      {
        access_controlled: true
      },
      i13nModel.params
    );

    return (
      <HoverButton
        {...this.props}
        i13nModel={i13nModel}
        componentShownOnHover={
          <span>
            You{' '}
            <Link href={ACCESS_LEVEL_DOCS} testid="access-denied__button-link">
              don't have access
            </Link>{' '}
            to this feature.
          </span>
        }
      />
    );
  }
}

type Props = {
  accessResources: Array<string>,
  permission: number,
  icon?: string
};

export default class AccessIconButton extends React.PureComponent<Props> {
  // TODO: I don't even know what's going on here!
  // As soon as this component is imported by any file in common/components/core
  // all properties from support/accessControl seems to get blown away
  // I'm using this to merge in the default props as a workaround
  // Is this a webpack issue? some other bundling issue?
  static defaultProps = {
    accessResources: ['channel_level_settings'],
    permission: 2
  };

  render() {
    const { accessResources, permission } = this.props;
    return (
      <AccessControlWrapper
        accessResources={accessResources}
        permission={permission}
        accessDeniedPropName="accessDenied"
      >
        <AccessInnerButton {...R.omit(ACCESS_CONTROL_PROPS, this.props)} />
      </AccessControlWrapper>
    );
  }
}
